import React from 'react';
import { CustomCheckbox } from '../CustomCheckbox';
;
export var Switch = function (_a) {
    var name = _a.name, color = _a.color, checked = _a.checked, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.id, id = _c === void 0 ? 'default-custom-switch-id' : _c, _d = _a.onChange, onChange = _d === void 0 ? function () { } : _d;
    return (React.createElement("div", { className: "switch-container " + (checked ? 'on' : 'off'), id: id },
        React.createElement(CustomCheckbox, { name: name, checked: checked, onChange: onChange, className: "switch " + className })));
};
